import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { accentTrainingData, getDataForDifficulty } from './data/skills/listening/accentTraining';

export default function AccentTraining() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : accentTrainingData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
